import { createFileRoute } from "@tanstack/react-router";

import { ModelPage, type ModelSearch } from "../../../workspaces/reports/pages/ModelPage";

export const Route = createFileRoute("/_console/p/$org/$project/reports/model")({
  validateSearch: (search: Record<string, unknown>): ModelSearch => ({
    ...(typeof search.table === "string" && search.table !== "" ? { table: search.table } : {}),
    ...(typeof search.sql === "string" && search.sql !== "" ? { sql: search.sql } : {}),
  }),
  component: ModelRoute,
});

function ModelRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <ModelPage search={search} onSearch={(next) => void navigate({ search: next, replace: true })} />;
}
